import MaterialIconsReact from "material-icons-react";
import { useNavigate } from "react-router-dom";
import styles from './SubHeader.module.css';
import SearchInput from "./SearchInput";
import { useContext, useEffect } from "react";
import { rudderStackTrackEvent } from "../plugins/analytics";
import { UserContext } from "../context/UserContext";
import { fetchItemList } from "../services/station";

function SubHeader(props) {
  const navigate = useNavigate();
  const {workOrder, setWorkOrder, selectedLocation, currentFactory, user} = useContext(UserContext);
  useEffect(() => {
    const workOrder = JSON.parse(localStorage.getItem('workOrder'));
    setWorkOrder(workOrder);
  }, [])

  const updateWorkOrder = (workOrder) => {
    localStorage.setItem('workOrder', JSON.stringify(workOrder));
    setWorkOrder(workOrder);
    rudderStackTrackEvent(
      "tars:on_workorder_select",
      {
        user_id: `TARS${user.id}`,
        email: user.email,
        action: "select",
        factory: currentFactory.item_code,
        station: selectedLocation.location
      }
    );
  }

  const onWorkOrderSearch = (value) => {
    return fetchItemList({
      key: value,
      location: selectedLocation.location,
      typefilter: {status: 'PRD', pending_parts: selectedLocation.station === 'qc' ? false : true, minlength: 0},
      typelist: ["WO"],
      _factory_code: currentFactory.item_code,
    });
  }

  return (
    <div className={styles.header}>
      <div className={styles.flexBlock}>
        {props.showBackButton && <span style={{marginRight: '16px'}}><MaterialIconsReact icon="arrow_back_ios_new" color={'#666666'} size={20} onClick={() => props.onBack ? props.onBack() : navigate(-1)}></MaterialIconsReact></span>}
        {props.subTitle ? <span style={{fontSize: '20px', fontWeight: 'bold' }}>{props.subTitle}</span> : props.left}
        {props.showSearch && <div style={{marginLeft: '20px'}}><SearchInput focus={props.focus} placeholder="Search by work order" onSearch={onWorkOrderSearch} onItemSelection={updateWorkOrder}></SearchInput></div>}
      </div>
      <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
        {props.showWorkOrder && <span className={styles.workOrder + ' ft-16'}>{workOrder && workOrder.wo_id ? workOrder.type + '-' + workOrder.wo_id : ''}</span>}
        {props.right}
      </div>
    </div>
  );
}

export default SubHeader;
